"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSubscriptionBenefitBanner = exports.mapSubscription = exports.mapShades = exports.mapProductsFromGql = exports.mapProductFromGql = exports.mapProductDiscontinuedAndCannotBeSold = exports.mapProductBase = exports.getProductSize = void 0;
var _productBox = require("@ori/product-box");
const getProductSize = ({
  volumeValue,
  volumeUnitText
}) => {
  if (volumeValue != null && volumeUnitText != null) {
    return `${volumeValue} ${volumeUnitText.trim()}`;
  }
  return null;
};
exports.getProductSize = getProductSize;
const mapProductDiscontinuedAndCannotBeSold = shades => {
  if (shades.length === 0) {
    return false;
  }
  return shades.every(shade => shade.isDiscontinued && !shade.canBeSold);
};
exports.mapProductDiscontinuedAndCannotBeSold = mapProductDiscontinuedAndCannotBeSold;
const mapSubscriptionBenefitBanner = data => ({
  title: data.title ?? '',
  message: data.message ?? '',
  readMoreText: data.readMoreLink?.title ?? '',
  readMoreUrl: data.readMoreLink?.relativeUrl ?? '',
  registerText: data.registerLink?.title ?? '',
  registerUrl: data.registerLink?.relativeUrl ?? '',
  signInText: data.signInLink?.title ?? ''
});
exports.mapSubscriptionBenefitBanner = mapSubscriptionBenefitBanner;
const mapSubscription = subscription => ({
  available: subscription?.available ?? false,
  deliveryFrequencyOptions: [...(subscription?.allowedFrequencies ?? [])],
  recommendedFrequency: subscription?.frequency ?? 0
});
exports.mapSubscription = mapSubscription;
const mapShades = shades => (shades ?? []).filter(shade => shade != null).map(shade => {
  const {
    hexColors,
    imageUrl
  } = (0, _productBox.mapShade)(shade);
  const {
    deal,
    ppa
  } = (0, _productBox.mapLabels)(shade.labels) ?? {};
  return {
    canBeReserved: shade.availability?.isBackorder ?? (0, _productBox.mapCanBeReserved)(shade.labels),
    canBeSold: (0, _productBox.mapCanBeSold)(shade.labels),
    canBeSubscribed: (0, _productBox.mapCanBeSubscribed)(shade.labels),
    isDiscontinued: shade.isDiscontinued,
    color: {
      name: shade.shadeName ?? null,
      hexColors,
      imageUrl
    },
    dealLabel: deal,
    imageUrl: shade.imageUrl ?? null,
    bonusPoints: shade.formattedPrice?.bp ?? 0,
    nextAvailableDateText: shade.productExpectedInbound?.expectedInboundLabel ?? null,
    pdpUrl: shade.pdpUrl?.relativeUrl ?? null,
    ppaLabel: ppa,
    price: {
      basicCashback: shade.formattedPrice?.price?.basicCashback ?? null,
      current: shade.formattedPrice?.price?.currentPrice ?? null,
      extraCashback: shade.formattedPrice?.price?.extraCashback ?? null,
      old: shade.formattedPrice?.price?.basicCataloguePrice ?? null,
      previousMinOfferPrice: shade.formattedPrice?.price?.previousMinOfferPrice ?? null,
      priceAfterImmediateDiscount: shade.formattedPrice?.price?.priceAfterImmediateDiscount ?? null
    },
    productCode: shade.productCode,
    size: getProductSize(shade),
    subscription: mapSubscription(shade.subscription),
    subscriptionBenefitBanner: shade.subscriptionBenefitBanner ? mapSubscriptionBenefitBanner(shade.subscriptionBenefitBanner) : null
  };
});
exports.mapShades = mapShades;
const mapProductBase = product => {
  const shades = mapShades(product?.concept?.products);
  if (!product?.concept?.name || shades.length === 0) {
    return null;
  }
  return {
    brandName: product.concept.brand?.name ?? null,
    brandUrl: product.concept.brand?.url ?? null,
    code: product.productCode,
    name: product.concept.name,
    ratingAverage: product.concept.ratingAverage ?? 0,
    ratingCount: product.concept.ratingCount ?? 0,
    shades,
    isDiscontinuedAndCannotBeSold: mapProductDiscontinuedAndCannotBeSold(shades)
  };
};
exports.mapProductBase = mapProductBase;
const mapProductFromGql = product => {
  const productBase = mapProductBase(product);
  if (!productBase) {
    return null;
  }
  const {
    brandName,
    brandUrl,
    code,
    name,
    ratingAverage,
    ratingCount,
    shades,
    isDiscontinuedAndCannotBeSold
  } = productBase;
  return {
    brandName,
    brandUrl,
    code,
    name,
    ratingAverage,
    ratingCount,
    shades,
    isDiscontinuedAndCannotBeSold
  };
};
exports.mapProductFromGql = mapProductFromGql;
const mapProductsFromGql = products => products.map(product => product ? mapProductFromGql(product) : null).filter(product => product != null);
exports.mapProductsFromGql = mapProductsFromGql;